import s from './parameters/state'
import * as a from './parameters/actions'
import * as m from './parameters/mutations'
import * as g from './parameters/getters'

export const state = s
export const actions = { ...a }
export const mutations = { ...m }
export const getters = { ...g }
